module.exports = __webpack_public_path__ + "static/img/wanDaTop.1d4559f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wanDaTop.png
// module id = fsz5
// module chunks = 2